import BackArrowBlue from "../../../svg/back-arrow-blue";

interface PharmaQuestionnaireHeaderProps {
  onBack: () => void;
}

const PharmaQuestionnaireHeader = (props: PharmaQuestionnaireHeaderProps) => {
  return (
    <div className="pharma-questionaire-form__header mb-4">
      <div
        className="pharma-questionaire-form__header-content flex items-center gap-1 text-h12 font-bold text-tertiaryBlue-4 hover:cursor-pointer"
        onClick={props.onBack}
      >
        <BackArrowBlue />
        Go Back
      </div>
    </div>
  );
};

export default PharmaQuestionnaireHeader;
